import { render, staticRenderFns } from "./BannerV2LocalizationForm.vue?vue&type=template&id=47a07462&scoped=true&"
import script from "./BannerV2LocalizationForm.vue?vue&type=script&lang=js&"
export * from "./BannerV2LocalizationForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerV2LocalizationForm.vue?vue&type=style&index=0&id=47a07462&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a07462",
  null
  
)

export default component.exports